var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 3.97166L8.00004 6.33366L14.6667 3.97166L8.00004 1.66699L1.33337 3.97166Z",
    fill: "#14161A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78226 1.03659C7.92338 0.987804 8.07679 0.987804 8.2179 1.03659L14.8846 3.34125C15.1523 3.43382 15.3323 3.68548 15.3334 3.96878C15.3345 4.25207 15.1564 4.50512 14.8894 4.59973L8.22272 6.96173C8.07868 7.01276 7.92148 7.01276 7.77744 6.96173L1.11078 4.59973C0.843743 4.50512 0.665668 4.25207 0.666753 3.96878C0.667838 3.68548 0.847847 3.43382 1.1156 3.34125L7.78226 1.03659ZM3.35149 3.97906L8.00008 5.62606L12.6487 3.97906L8.00008 2.37205L3.35149 3.97906Z",
    fill: "#14161A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.704113 6.44661C0.825745 6.0991 1.20607 5.91598 1.55359 6.03761L8.00002 8.29386L14.4465 6.03761C14.794 5.91598 15.1743 6.0991 15.2959 6.44661C15.4176 6.79413 15.2344 7.17446 14.8869 7.29609L8.22025 9.62942C8.07767 9.67932 7.92237 9.67932 7.77979 9.62942L1.11312 7.29609C0.7656 7.17446 0.582482 6.79413 0.704113 6.44661ZM0.704113 9.11328C0.825745 8.76576 1.20607 8.58264 1.55359 8.70428L8.00002 10.9605L14.4465 8.70428C14.794 8.58264 15.1743 8.76576 15.2959 9.11328C15.4176 9.4608 15.2344 9.84112 14.8869 9.96275L8.22025 12.2961C8.07767 12.346 7.92237 12.346 7.77979 12.2961L1.11312 9.96275C0.7656 9.84112 0.582482 9.4608 0.704113 9.11328ZM0.704113 11.7799C0.825745 11.4324 1.20607 11.2493 1.55359 11.3709L8.00002 13.6272L14.4465 11.3709C14.794 11.2493 15.1743 11.4324 15.2959 11.7799C15.4176 12.1275 15.2344 12.5078 14.8869 12.6294L8.22025 14.9628C8.07767 15.0127 7.92237 15.0127 7.77979 14.9628L1.11312 12.6294C0.7656 12.5078 0.582482 12.1275 0.704113 11.7799Z",
    fill: "#14161A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSftIcon);
export default __webpack_public_path__ + "static/media/sft-icon.1071a413ab40561eca271bc577ac6c04.svg";
export { ForwardRef as ReactComponent };